import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

const ranks = articles.slice(0, 5);

export default function FocusRank() {
  const [lead, ...rest] = ranks;

  return (
    <section id="focus" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          kicker="Focus Ranking"
          title="本季焦点翻车榜"
          description="按现场讨论度整理的高热片段。我们不给选手打分，只按画面里真实发生的顺序聊清前因后果。"
          actionLabel="查看全部翻车现场"
          actionTo="/category/fails"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="group relative overflow-hidden rounded-lg border border-background-200 lg:col-span-7">
            <Link to={`/article/${lead.id}`} className="block">
              <div className="relative h-64 w-full overflow-hidden md:h-80">
                <img
                  src={lead.cover}
                  alt={`${lead.title} 配图`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  榜一 · 讨论度最高
                </span>
                <div className="absolute bottom-0 left-0 w-full p-5 md:p-6">
                  <p className="mb-2 text-xs tracking-wide text-accent-300">
                    {lead.categoryName} · {lead.date}
                  </p>
                  <h3 className="font-heading text-lg font-bold leading-snug text-background-50 md:text-2xl">
                    {lead.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm text-background-200">
                    {lead.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          </article>

          <ol className="flex flex-col gap-3 lg:col-span-5">
            {rest.map((item, index) => (
              <li key={item.id}>
                <Link
                  to={`/article/${item.id}`}
                  className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 hover:bg-background-50"
                >
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-foreground-950 font-heading text-sm font-bold text-background-50">
                    {index + 2}
                  </span>
                  <span className="flex-1">
                    <span className="block font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                      {item.title}
                    </span>
                    <span className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                        {item.categoryName}
                      </span>
                      <span>{item.readTime}</span>
                    </span>
                  </span>
                  <span className="mt-1 inline-flex h-4 w-4 shrink-0 items-center justify-center text-foreground-400 transition-transform group-hover:translate-x-0.5">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}